export default __webpack_public_path__ + "static/media/cx_cover_c40s.d6ee032a.jpg";